import { Image, ImageOptions } from '@tiptap/extension-image'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    UpdatedImage: {
      setImage: (options: {
        src: string
        alt?: string
        title?: string
        width?: number
        height?: number
      }) => ReturnType
      /**
       * Set the image's title.
       */
      setTitle: (title: string | null) => ReturnType
      /**
       * Check if the image has a title.
       */
      hasTitle: () => ReturnType
    }
  }
}

export const UpdatedImage = Image.extend<
  ImageOptions & {
    getTeamAndRepo: () => { teamSlug: string | null; repoSlug: string | null }
  }
>({
  addOptions() {
    return {
      ...this.parent?.(),
      getTeamAndRepo: () => {
        return { teamSlug: null, repoSlug: null }
      },
    }
  },
  addAttributes() {
    return {
      ...this.parent?.(),
      caption: {
        default: null,
        parseHTML: (el) => el.getAttribute('data-caption'),
        renderHTML: (attributes) => {
          if (!attributes.caption) {
            return {}
          }

          return {
            'data-caption': attributes.caption,
          }
        },
      },
      width: {
        default: null,
        parseHTML: (element) => element.getAttribute('width'),
        renderHTML: (attributes) => {
          if (!attributes.width) {
            return {}
          }

          return {
            width: attributes.width,
          }
        },
      },
      height: {
        default: null,
        parseHTML: (element) => element.getAttribute('height'),
        renderHTML: (attributes) => {
          if (!attributes.width) {
            return {}
          }

          return {
            height: attributes.height,
          }
        },
      },
      aspectRatio: {
        default: null,
        parseHTML: (element) => element.getAttribute('aspect-ratio'),
        renderHTML: (attributes) => {
          if (!attributes.aspectRatio) {
            return {}
          }

          return {
            'aspect-ratio': attributes.aspectRatio,
          }
        },
      },
    }
  },

  addCommands() {
    return {
      setTitle:
        (title: string | null) =>
        ({ commands }) => {
          return commands.updateAttributes('image', { caption: title })
        },
      hasTitle() {
        return ({ editor }) => !!editor.getAttributes('image').caption
      },
    }
  },
})
